export enum OntologyEnum {
  Controller_Entity = 1,
  Player_Audience_Entity = 2,
  Training_Audience_Process = 3,
  Event_Type = 4,
  User_Role = 5,
  Location = 6,
  Organization = 7,
  Injection_Means = 8,
  Actors = 9,
  Functional_Area = 10,
  Topic = 11,
  Security_Status = 12,
  Objective_Type = 13,
  Service_Type = 14,
  Function_Type = 15,
  Headquarters_Entity = 16,
  Crises_Type = 17,
  Communications_Means = 18,
  Plan = 19,
  Order = 20,
  Report = 21,
  Joint_Process = 22,
  Incident = 23,
  Mean_of_Delivery = 24,
}
